// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute, redirect } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/home/-components/component";
import getPharmacyID from "@/utils/pharmacy_code";
import { Loading } from "@/layouts/loading";
import { httpClient } from "@/httpClient";
import { PharmacyCodeList } from "./-components/modal";
import { pharmacyClient } from "@/connect";

const API_URL = import.meta.env.VITE_API_URL;
export const Route = createFileRoute("/(pharma)/_layout/home/")({
  component: Component,
  beforeLoad: () => {
    if (getPharmacyID() !== "") {
      redirect({
        to: "/overview",
        replace: true,
      })
    }
  },
  loader: async (): Promise<PharmacyCodeList> => {
    try {
        const data = await pharmacyClient.getBranchesForCompany({
            companyCode: '', // Get from auth context
        })
        
        return data.branches.map(branch => ({
            pharmacy_code: branch.pharmacyCode,
            pharmacy_name: branch.pharmacyName,
        })) as PharmacyCodeList
    } catch (error) {
        throw new Error("Failed to fetch pharmacy list")
    }
},
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1
})